import { defaultFaqs, FAQ } from "./faq"
import Script from "next/script"

export default function FaqWrapper() {
  return (
    <div>
      <Script
        id="faq-schema"
        type="application/ld+json"
        strategy="afterInteractive"
      >
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: defaultFaqs?.map?.((faq) => ({
            "@type": "Question",
            name: faq.question,
            acceptedAnswer: {
              "@type": "Answer",
              text: faq.answer.replace(/\n+/g, " ").trim(),
            },
          })),
        })}
      </Script>
      <FAQ />
    </div>
  )
}
